import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { NavLink } from 'react-router-dom';
import parse from 'html-react-parser';
import GLOBAL_CONFIG from '../../config/config';
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle, scrollToElement, navParticipationMenu, } from '../../modules/helpers';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
import CampaignServices from "../../Services/Campaign";
import Scrolltop from '../../modules/scrolltop';
import ValidateForm from '../../modules/validate';
import banner from '../../components/Layout/Banner';

const winnerPrize = {
  euro: "/resources/images/wheelspin/euro-wheel.png",
  gutschein: "/resources/images/wheelspin/gutschein-wheel.png",
  einkauf: "/resources/images/wheelspin/einkauf-wheel.png",
  noWin: ""
}

const ISWINNER = {
  WIN: 1,
  LOOSE: 0
}
const WINNER_CODE = {
  GUTSCHEIN1: 1,
  GUTSCHEIN2: 2,
  EINKAUF: 3,
  NOWIN: 4,

  
} 

const SPINDEGREEEDEKA = [
  { id: 1, class: "one", deg: 0, winCode: WINNER_CODE.EURO },
  { id: 2, class: "two", deg: 36, winCode: WINNER_CODE.NOWIN },
  { id: 3, class: "three", deg: 67, winCode: WINNER_CODE.GUTSCHEIN1 },
  { id: 4, class: "four", deg: 107, winCode: WINNER_CODE.NOWIN },
  { id: 5, class: "five", deg: 144, winCode: WINNER_CODE.EINKAUF },
  { id: 6, class: "six", deg: 180, winCode: WINNER_CODE.NOWIN },
  { id: 7, class: "seven", deg: 216, winCode: WINNER_CODE.GUTSCHEIN2 },
  { id: 8, class: "eight", deg: 252, winCode: WINNER_CODE.NOWIN },
  { id: 9, class: "nine", deg: 290, winCode: WINNER_CODE.EINKAUF },
  { id: 10, class: "ten", deg: 327, winCode: WINNER_CODE.NOWIN },
];

class WheelSpin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false,

      spinDegree: SPINDEGREEEDEKA,
      firstRotate: true,
      prizeList: [],
      WinCode: 2,
      isWin: -1,
      ParticipationId: "",
      Consumerid: "",
      loaderSubmit: false,
      loaderGeneralError: false,
      genericErrorMessage: "",
      showPopup: false,
      showCashback: false,
      errorSalutation: false,
      errorFirstName: false,
      errorLastName: false,
      errorIban: false
    };
    // this.ProcessFormData = this.ProcessFormData.bind(this);
  }
  
  resize() {
      this.setState({ isMobile: window.innerWidth <= 768 });
  }

  componentWillMount() {
    window.addEventListener("resize", this.resize);
    this.resize();

    if (sessionStorage.getItem(GLOBAL_CONFIG.Session.userstatus) === null) {
      //Go to particaption page
      this.props.history.push({ pathname: GLOBAL_CONFIG.Route.home });
    }

    switch (window.PROMOTION_CAMPAIGN) {
      case "gluecksrad":
        this.setState({ spinDegree: SPINDEGREEEDEKA })
        break
    }

  }

  componentDidMount() {
    const { t } = this.props;
    //Active menu participation - mitmachen
    // navParticipationMenu(true);
    //Remove main loader
    mainLoaderToggle('hide');

    if (document.querySelector(`.parent__wheel__${window.PROMOTION_CAMPAIGN}`)) {
      document.querySelector(`.main-content`).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    //Virtual page
    appGoogleTracking.dataLayerPush({
      'customEvent': {
        'event': 'virtual-page',
        'virtualUri': GLOBAL_CONFIG.Route.thankyou,
        'pageTitle': t('Meta.title'),
        'ParticipantId': window.PARTICIPATION_ID
      }
    });



    const spinContent = this.spinContentRef;
    const prizeList = [];
    // if(this.state.isWin == ISWINNER.WIN){

    for (let i = 0; i < spinContent.childNodes.length; i++) {
      if (spinContent.childNodes[i].className != undefined) {
        prizeList.push(spinContent.childNodes[i].className);
      }
    }
    this.setState({ prizeList });
    // }



  }
  componentWillUnmount() {
    mainLoaderToggle('show');
  }


  displayTitleContent(t) {
    return (
      <>
        {window.PROMOTION_CAMPAIGN == "edeka" ?
          <>
            <TitleContent
              heading={parse(t('Page.Game.title'))}
              subheading={parse(t('Page.Game.paragraph'))}
            />
            {/* <TitleContent
              heading={parse(t('Page.Game.title2'))}
              subheading={parse(t('Page.Game.paragraph2'))}
            /> */}
          </>
          : <TitleContent
            heading={parse(t('Page.Game.title'))}
            subheading={parse(t('Page.Game.paragraph'))}
          />
        }
      </>
    );
  }
  displayTitleContentCashBack(t) {
    return (
      <>
        {window.PROMOTION_CAMPAIGN == "edeka" &&
          <TitleContent
            heading={parse(t('Page.Game.CashbackTitle'))}
            subheading={parse(t('Page.Game.Cashbackparagraph'))}
          />

        }
      </>
    );
  }

  startSpinning = () => {
    const container = this.containerRef;
    container.style.transition = "none";
    container.style.animation = "none";
    const headWheel = document.querySelector('.head');
    container.style.backgroundImage = "url('/resources/images/wheelspin/wheel.png')";
    headWheel.style.display = 'block';

    // Make the wheel spin continuously while waiting for API response
    let rotation = 0;
    this.spinningInterval = setInterval(() => {
        rotation += 10;
        container.style.transform = `rotate(${rotation}deg)`;
    }, 50);
  };

  stopSpinning = () => {
      clearInterval(this.spinningInterval);
      
      setTimeout(()=>{
        this.handleClick();
      },100)
  };


  handleClick = () => {
    const { firstRotate, spinDegree } = this.state;
    const container = this.containerRef;
    const btn = this.btnRef;
    const headWheel = document.querySelector('.head');
    
    btn.disabled = true;
    
    // Random spin values
    const indexWin = spinDegree.findIndex((prize) => prize.winCode == this.state.WinCode);

    
    // console.log('index', indexWin)
    // console.log('obj', spinDegree[indexWin])

    // Calculate win angles
    let number = spinDegree[indexWin].deg;
    number = (360 * 3) - number;


    container.style.backgroundImage = "url('/resources/images/wheelspin/wheel.png')";
    headWheel.style.display = 'block';


    container.style.transition = "5s";
    container.style.transform = `rotate(${number}deg)`;
    // Spin wheel


    // // Add prize win animation
    // setTimeout(() => {

    //   btn.disabled = false;
    //   setTimeout(() => {
    //     if (this.state.WinCode == WINNER_CODE.CASHBACK) {
    //       this.setState({ showCashback: true });
    //       document.querySelector(`.s-content-title`).scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     } else {
    //       // this.props.history.push({ pathname: GLOBAL_CONFIG.Route.thankyou });
    //     }
    //   }, 5000);
    // }, 5500);

    this.setState({ firstRotate: false });



  };
  handleClickV1 = () => {
    let audio = new Audio('/resources/audio/spin-sound11.mp3');

    // Start playing the sound
    audio.loop = true;
    audio.play();


    this.startSpinning();

    // this.handleClick()
    if (this.state.isWin === -1) {
      let dataStorage = JSON.parse(sessionStorage.getItem(GLOBAL_CONFIG.Session.userinfo));


      this.retrieveFileFromIndexedDB(dataStorage.fileinput, (files) => {
       
      //  console.log('retrievFiles',files);
       
        if (files) {
          dataStorage.fileinput = files;
          let _data = new FormData();

          for (let key in dataStorage) {
            _data.append(key, dataStorage[key]);
          }
          // console.log('data_______', _data);
          CampaignServices.Participate({
            data: _data,
            retailer: window.PROMOTION_CAMPAIGN,
          })
            .then((response) => {
              let { success, message, ParticipationId, data } = response.data;

              if (success) {
                let { IsWin, WinTier, WinType, ParticipationId, Consumerid } = data;
                this.state.WinCode = WinTier;
                this.state.isWin = IsWin;
                this.state.ParticipationId = ParticipationId;
                this.state.Consumerid = Consumerid;
                localStorage.setItem("wincode",WinTier);
                localStorage.setItem('winTier', WinTier)
                localStorage.setItem('participationData', JSON.stringify(response.data))
                
                this.stopSpinning();
                
                setTimeout(() => {
                  audio.pause();
                  this.props.history.push({ pathname: GLOBAL_CONFIG.Route.thankyou });
                }, 5500)
                
                appGoogleTracking.dataLayerPush({
                  dataEvent: "spin_the_wheel",
                  dataCategory: "Gamification Page",
                  dataAction: "Click on Spin Now",
                  dataLabel: "GAME_GP_PART",
                });


              } else {
                let errorStatus = data.Error[0];
                audio.pause();
                if (!!errorStatus) {
                  sessionStorage.setItem('errorMessage',data.Error[0])
                  this.setState({ showPopup: true });
                }
              }
              //delete ressource here
              sessionStorage.removeItem(GLOBAL_CONFIG.Session.userstatus)
              sessionStorage.removeItem(GLOBAL_CONFIG.Session.userinfo)
              sessionStorage.setItem('userWin', 'userWin')
              // Clear all files from IndexedDB object store
              this.clearIndexedDB();
            })
            .catch((error) => {
              let { Data } = error.response.data,
                errorStatus = Data.Error[0] || "";
                audio.pause();
            });
        } else {
          console.log('File not found.');
        }
      });
    }
  };
  clearIndexedDB() {
    const dbName = 'fileDatabase';
    const objectStoreName = 'files';
    const request = window.indexedDB.open(dbName, 1);

    request.onsuccess = (event) => {
      const db = event.target.result;
      const transaction = db.transaction(objectStoreName, 'readwrite');
      const objectStore = transaction.objectStore(objectStoreName);

      // Clear all files from the object store
      const clearRequest = objectStore.clear();

      clearRequest.onsuccess = () => {
        db.close();
      };

      clearRequest.onerror = (event) => {
        console.error('Error clearing files from IndexedDB:', event.target.error);
        db.close();
      };
    };

    request.onerror = (event) => {
      console.error('IndexedDB error:', event.target.error);
    };
  }

  spinContent() {
    const { t } = this.props; 
    return (
      <div className="temporary_div">
          <div className='pink-section'> 
            <div className='pink-section-mobile'></div>
            <div className="foot-snow">
              <div className='left-wheel'>
                <p>
                {this.state.isMobile ? parse(t('Page.Home.wheelText.left.mobile')) : parse(t('Page.Home.wheelText.left.desktop'))}
                
                </p>
                <button
                  onClick={() => {
                    this.handleClickV1()
                  }}
                >
                  <div className="btn__container btn--primary btn--hover" style={{ width: '200px' }}>
                    <span className="btn__text">JETZT Drehen!</span>
                  </div>
                </button>
              </div>
              <div>
                <div className='head'>
                </div>
                <div className="wheel__spin__container" ref={(ref) => (this.containerRef = ref)}>
                  <button id="spin"
                    ref={(ref) => (this.btnRef = ref)}
                    onClick={this.handleClickV1}
                  ></button>
                  <div className="spin"
                    ref={(ref) => (this.spinContentRef = ref)}
                  >
                    <div className="one"></div>
                    <div className="two"></div>
                    <div className="three"></div>
                    <div className="four"></div>
                    <div className="five"></div>
                    <div className="six"></div>
                    <div className="seven"></div>
                    <div className="eight"></div>
                    <div className="nine"></div>
                    <div className="ten"></div>
                  </div>
                </div>
              </div>
              <div className='right-wheel'>
              <p>{this.state.isMobile ? parse(t('Page.Home.wheelText.right.mobile')) : parse(t('Page.Home.wheelText.right.desktop'))}</p>
              </div>

          </div>
          </div>
        
      </div>
    );
  }
  

  render() {
    const { t } = this.props;
    let spinContent = null;
    let titleContent = null;


    if (this.state.WinCode == WINNER_CODE.CASHBACK && this.state.showCashback) {
    } else {
      switch (window.PROMOTION_CAMPAIGN) {
        case "gluecksrad": spinContent = <div className={`parent__wheel__${window.PROMOTION_CAMPAIGN}`}>{this.spinContent()} </div>
          break
      }
      titleContent = this.displayTitleContent(t);
    }



    return (
      
      <div className={`content-confirmation content-wheelspin__${window.PROMOTION_CAMPAIGN}`}>
        <div className='background-light'></div>
        <div className='wheel-title'>
          <picture>
            <source srcSet='/resources/images/wheelspin/spin-title.png' media='(min-width: 500px)' />
            <img src='/resources/images/wheelspin/spin-title-mobile.png'/>
          </picture>
          
        </div>
        
        {spinContent}
        {this.state.showPopup ?
          <>
            <div className="js-overlay overlay overlay--black">
              <div className="overlay__container overlay__content">
                <div
                  className="overlay__close"
                  onClick={()=>{
                    this.setState({showPopup: false});
                    this.props.history.push({ pathname: GLOBAL_CONFIG.Route.home });
                  }}
                ></div>
                <p id="js-error-msg">
                  {(() => {
                    const errorMessage = sessionStorage.getItem('errorMessage');

                    if (errorMessage === 'DAILY_PARTICIPATION_LIMIT_EXCEEDED') {
                      return "Leider has du bereits teilgenommen und gewonnen. Jeder Teilnehmer kann nur einmal gewinnen.";
                    } else if (errorMessage === 'INVALID_RECEIPT') {
                      return "FEHLER: Der hochgeladene Kassenbon ist ungültig. Bitte laden Sie einen gültigen Kassenbon hoch."
                    } else if (errorMessage === 'INVALID_TERMS') {
                      return "FEHLER: Sie haben die Teilnahmebedingungen nicht akzeptiert. Bitte stimmen Sie den Bedingungen zu, um fortzufahren."
                    } else if (errorMessage === "BLACKLISTED_EMAIL") {
                      return "FEHLER: Die eingegebene E-Mail-Adresse ist gesperrt. Bitte verwenden Sie eine andere E-Mail-Adresse."
                    } else if (errorMessage === 'CAPTCHA_ERROR') {
                      return "FEHLER: CAPTCHA FEHLER"
                    } else if (errorMessage === 'AN_ERROR_HAS_OCCURED') {
                      return "FEHLER: Sie haben die Teilnahmebedingungen nicht akzeptiert. Bitte stimmen Sie den Bedingungen zu, um fortzufahren."
                    }
                     else {
                      return "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
                    }
                  })()
                }
                </p>
              </div>
            </div>
          </>
          : null}
        {this.state.loaderGeneralError ? (
          <div className="js-overlay overlay overlay--black">
            <div className="overlay__container overlay__content">
              <div
                className="overlay__close"
                onClick={this.onClosePopupHandler}
              ></div>
              <p id="js-error-msg">{parse(this.state.genericErrorMessage)}</p>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  ProcessFormData(event) {
    event.preventDefault();
    //Open loader
    let validateForm = ValidateForm.validateForm("frm_participation")
    if (validateForm === true) {
      let data = {
        salutation: this._DETAILS_salutation.value,
        firstname: this._DETAILS_firstName.value,
        lastname: this._DETAILS_lastName.value,
        iban: this._DETAILS_iban.value,
        entryId: this.state.ParticipationId,
        consumerId: this.state.Consumerid
      };
      //Form Data is used to passe the receipt as binary
      CampaignServices.CashBack({
        data: data,
        retailer: window.PROMOTION_CAMPAIGN,
      })
        .then((response) => {
          let { success, message, ParticipationId, data } = response.data;
          if (success) {
            appGoogleTracking.dataLayerPush({
              'dataEvent': 'send_data_link',
              'dataCategory': 'Cashback Page',
              'dataAction': 'Click on Send Data button link',
              'dataLabel': 'GAME_CB_PART'
            });
            this.props.history.push({ pathname: GLOBAL_CONFIG.Route.spinconfirmation });
            //Go to Thank you page
          } else {
            let errorStatus = data.Error[0];
            if (!!errorStatus) {
              // this.ProcessError(errorStatus);

            }
          }
        })
        .catch((error) => {
          let { Data } = error.response.data,
            errorStatus = Data.Error[0] || "";
          this.ProcessError(errorStatus);
        });
    } else {
      if (this.state.errorFirstName || this.state.errorLastName || this.state.errorIban || this.state.errorSalutation) {
        event.target.classList.add("notvalid");
        event.target.classList.remove("valid");
      }
    }
  }

  ProcessError(_ERR) {
    this.setState({
      loaderSubmit: false,
      loaderGeneralError: true,
      genericErrorMessage: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
    });
  }

  onClosePopupHandler() {
    this.setState({
      showPopup:false
      // loaderError: false,
      // loaderGeneralError: false
    });
    // window.location.replace('https://www.milka.de');
  };

  retrieveFileFromIndexedDB(fileName, callback) {
    const request = window.indexedDB.open('fileDatabase', 1);

    request.onsuccess = (event) => {
      const db = event.target.result;
      const transaction = db.transaction('files', 'readonly');
      const objectStore = transaction.objectStore('files');

      const request = objectStore.get(fileName);

      request.onsuccess = (event) => {
        const fileData = event.target.result;

        if (fileData) {
          callback(fileData.content);
        } else {
          callback(null); // File not found
        }
      };
    };
  }

}

export default withTranslation()(WheelSpin);